import AWSAppSyncClient from 'aws-appsync'
import { AUTH_TYPE } from 'aws-appsync/lib'
import { API_URL } from './api-url'
import { signOutUser } from './aws-api'
import { getAuthAdapter } from '@shell/adapters/auth'

export const getClient = async () =>
  new AWSAppSyncClient(
    {
      // @ts-ignore
      url: API_URL,
      // @ts-ignore
      region: process.env.AWS_S3_REGION,
      // @ts-ignore
      auth: {
        type: process.env.CHINA_DEPLOYMENT ? AUTH_TYPE.OPENID_CONNECT : AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        // @ts-ignore
        jwtToken: async () => {
          try {
            return await getAuthAdapter().getIdToken()
          } catch (e) {
            // go back to sso when credentials expire
            // signout user here
            await signOutUser()
            return null
          }
        },
      },
      credentials: () => getAuthAdapter().getCredentials(),
      // Uses Amazon IAM credentials to authorize requests to S3.
      complexObjectsCredentials: () => getAuthAdapter().getCredentials(),
      disableOffline: true,
    },
    {
      resolvers: {
        Mutation: {
          resetFlex: (_root, variables, { cache }) => {
            const { resetFlex } = variables
            cache.writeData({ data: { resetFlex } })
            return null
          },
        },
      },
    }
  )
